import { initSentryClient } from '@denqfabrik/sentry/client';

initSentryClient({ appName: 'denqfabrik-landing' });

import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';

const root = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// A pre-rendered page arrives with its markup inside #root: adopt it, do not rebuild it. Every
// other path (blog, thank-you pages, dev server) is served the empty shell and renders here.
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
